import {
  BlockIdentifier,
  InlineIdentifier
} from '../identifiers'
import {
  DuplicateElementTypeError,
  DuplicatePatternError,
  ParserConfigVersionNotANumberError
} from '../exceptions'
import {
  ElementConverter,
  OptionConverter,
  TextConverter
} from '../converters'


class ParserConfig {

  static validateElements(elementConverters) {
    let elementTypes = []
    for (let i in elementConverters) {
      const elementConverter = elementConverters[i]
      if (!elementTypes.includes(elementConverter.type)) {
        elementTypes.push(elementConverter.type)
      } else {
        throw new DuplicateElementTypeError(elementConverter.type)
      }
    }
  }

  static validatePatterns(inputPatterns) {
    let patterns = []
    for (let i in inputPatterns) {
      const pattern = inputPatterns[i]
      if (!patterns.includes(pattern)) {
        patterns.push(pattern)
      } else {
        throw new DuplicatePatternError(pattern)
      }
    }
  }

  constructor(version = 1, inputElementConverters = [], textOpenPattern = '{',
    textClosePattern = '}', optionOpenPattern = '(', optionClosePattern = ')') {

    this.version = parseInt(version)
    if (Number.isNaN(this.version)) throw new ParserConfigVersionNotANumberError(version)

    this.blockElementsByOpening = {}
    this.blockElementsByType = {}
    this.inlineElementsByClosing = {}
    this.inlineElementsByOpening = {}
    this.inlineElementsByType = {}

    const elementConverters = [
      ParserConfig.ELEMENT_CONVERTER_PARAGRAPH,
      ...inputElementConverters
    ]

    // Validate patterns and element types
    const inlineConverter = elementConverters.filter(e => e.markupIdentifier.isInline)
    ParserConfig.validatePatterns([
      textOpenPattern,
      textClosePattern,
      optionOpenPattern,
      optionClosePattern,
      ...inlineConverter.map(c => c.markupIdentifier.openPattern),
      ...inlineConverter.map(c => c.markupIdentifier.closePattern)
    ])

    // Separate batch for the block elements since there's no issue if the closing pattern from Text, Option or
    // an inline element matches the open pattern of a block element
    ParserConfig.validatePatterns([
      textOpenPattern,
      optionOpenPattern,
      ...elementConverters.filter(e => !e.markupIdentifier.isInline).map(e => e.markupIdentifier.openPattern)
    ])
    ParserConfig.validateElements(elementConverters)

    elementConverters.forEach(elementConverter => {
      const openPattern = elementConverter.markupIdentifier.openPattern
      const closePattern = elementConverter.markupIdentifier.closePattern
      if (elementConverter.markupIdentifier.isInline) {
        this.inlineElementsByType[elementConverter.type] = elementConverter
        this.inlineElementsByOpening[openPattern] = elementConverter
        this.inlineElementsByClosing[closePattern] = elementConverter
      } else {
        this.blockElementsByType[elementConverter.type] = elementConverter
        this.blockElementsByOpening[openPattern] = elementConverter
      }

      this.textConverter = new TextConverter(new InlineIdentifier(textOpenPattern, textClosePattern, true))
      this.optionConverter = new OptionConverter(new InlineIdentifier(optionOpenPattern, optionClosePattern))
      this.possibleMatches = new Set([
        optionClosePattern,
        textOpenPattern,
        textClosePattern,
        ...Object.keys(this.inlineElementsByOpening),
        ...Object.keys(this.inlineElementsByClosing)
      ])
    })
  }
}

ParserConfig.ELEMENT_PARAGRAPH_OPEN_PATTERN = ''
ParserConfig.ELEMENT_CONVERTER_PARAGRAPH = new ElementConverter(
  new BlockIdentifier(ParserConfig.ELEMENT_PARAGRAPH_OPEN_PATTERN, false, true),
  'paragraph'
)

export default ParserConfig